require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2003-10-27-mod-auth-project-and-what-is-open-source-for-me.json") })
        }
      }, "path---articles-2003-10-27-mod-auth-project-and-what-is-open-source-for-me");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2003-10-27-mod-auth-project-and-what-is-open-source-for-me!./.cache/json/articles-2003-10-27-mod-auth-project-and-what-is-open-source-for-me.json
// module id = 336
// module chunks = 231608221292675